export { default } from './Redactor';
